export const APP_CONSTANTS = {
  tokenKey: 'access_token',
  userKey: 'current_user',
} as const;
